<template>
  <Legenda titulo="Sugestão em galão" :legenda="TXT_CALCULO">
    {{ GALONAGEM }}
  </Legenda>
</template>

<script>
import Legenda from "@/components/produto/detalhes/Legenda";
import {calcular_sugestao_em_galao, FATOR_DIVISAO} from "@/components/compra/fornecedor/GalonagemProduto/CalcularSugestaoEmGalao";

export default {
  name: "GalonagemProduto",
  components: {Legenda},
  props: {
    produto: {
      validator(prop) {
        const chaves_prop = Object.keys(prop);
        const chaves_obrigatorias = ['sugestao', 'litragem'];
        return chaves_obrigatorias.every(chave => chaves_prop.includes(chave));
      },
    }
  },
  data: () => ({
    fator_divisao: 3.785
  }),
  computed: {
    GALONAGEM() {
      return this.Helpers.formatarValor(calcular_sugestao_em_galao(this.produto));
    },
    TXT_CALCULO() {
      return `(${this.Helpers.formatarValor(this.produto.sugestao)} * ${this.Helpers.formatarValor(this.produto.litragem)}) / ${this.Helpers.formatarValor(FATOR_DIVISAO)} = ${this.GALONAGEM}`;
    }
  }
}
</script>

<style scoped>

</style>
